import Application from "./index";

const app = new Application();

export default app;